import { useMemo } from 'react';

import useModularPDPCart from 'data-hooks/useModularPDPCart';
import { getPriceDetailsUtil } from 'data-hooks/utils';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePDPPrice from 'data-hooks/usePDPPrice';

const usePDPTieredPrice = (
  priceObj = null,
  promotion = null,
  optionPrice = 0,
  productId = null,
  slug = null
) => {
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const productPriceData = usePDPPrice(productId, slug);

  const { data: priceData = {}, loading } = priceObj
    ? { loading: false }
    : productPriceData;

  const { data: modularCartData } = useModularPDPCart(productId, slug);

  const priceDetails = useMemo(() => {
    if (priceObj) {
      return getPriceDetailsUtil(priceObj, promotion, optionPrice, false);
    }

    if (!priceData) {
      return {};
    }

    if (pdpIsModularBYOProduct) {
      return {
        priceWithOptionsPrice: modularCartData?.modularTotalPrice,
      };
    }

    return getPriceDetailsUtil(
      priceData?.price,
      priceData?.promotion,
      priceData?.optionPrice,
      priceData?.isClearance
    );
  }, [
    priceObj,
    priceData,
    pdpIsModularBYOProduct,
    promotion,
    optionPrice,
    modularCartData?.modularTotalPrice,
  ]);

  return {
    loading,
    priceDetails,
  };
};

export default usePDPTieredPrice;
